import React, { useState,useEffect, useCallback, useMemo } from 'react'
import { Icon} from "semantic-ui-react"
import {MessageBeforeList} from './MessageBeforeList'
import ReactDOM from 'react-dom';
import {useNotification} from '../../hooks'
import { STORAGE_KEYS } from '../../utils/constantes'

export const Notification = React.memo(() => {
    const  [showMessage,setShowMessage] = useState(false)
    const  [bellActive,setBellActive] = useState(false)
  
    const { lastNotificationInfo,hiddenNotification } = useNotification();
    const  [closeMessage,setCloseMessage] = useState(true)

    const [portalRoot] = useState(() => {
      const root = document.createElement('div');
      root.style.position = 'absolute';
      root.style.bottom = '0%';
      root.style.right = '1%';
      root.style.zIndex = '1000';
      root.style.top = '10%';
      root.style.width = '30%';
      root.style.height = '20%';
      // Agrega otros estilos según sea necesario
      return root;
    });

     const verificarShowBell = useCallback(()=>{
        const notificationData = localStorage.getItem(STORAGE_KEYS.NOTIFICATION_DATA);
        if (notificationData === null) return;
        
        let parsedData = JSON.parse(notificationData);
        if (parsedData.length > 0) {
            if (parsedData.some(objeto => objeto.show === false)){
                setBellActive(true)
            }else{
                setBellActive(false)
            }
        }
    }, []) 

    const verificarShowNotification = useCallback(()=>{
      const notificationData = localStorage.getItem(STORAGE_KEYS.NOTIFICATION_DATA);
      if (notificationData === null) return;
      
      let parsedData = JSON.parse(notificationData);
      if (parsedData.length > 0) {
          parsedData.forEach(noti=>{
            noti.show = true;
          })
          
          localStorage.setItem(STORAGE_KEYS.NOTIFICATION_DATA, JSON.stringify(parsedData));
          verificarShowBell()
      }
    }, [verificarShowBell])
    
    useEffect(()=>{
        verificarShowBell()
    },[verificarShowBell])
    
    useEffect(()=>{
        verificarShowBell()
    },[showMessage, verificarShowBell])
   
   const viewNotification = useCallback(()=>{
        setShowMessage(true)
        document.body.appendChild(portalRoot);
        verificarShowNotification()
   }, [portalRoot, verificarShowNotification])
   
   const close = useCallback(()=>{
    setCloseMessage(false)
    setShowMessage(false)
    hiddenNotification()
    verificarShowNotification()
    
    document.body.removeChild(portalRoot);
   }, [portalRoot, hiddenNotification, verificarShowNotification])

    const parsedData = useMemo(() => {
        const notificationData = localStorage.getItem(STORAGE_KEYS.NOTIFICATION_DATA);
        return notificationData === null ? [] : JSON.parse(notificationData);
    }, [showMessage, lastNotificationInfo]);

    const count = useMemo(() => {
        return parsedData.filter(objeto => objeto.show === false).length;
    }, [parsedData]);

    const MensajeNot = useMemo(() => {
        if (parsedData.length === 0) return null;
        
        return parsedData.map((noti)=>(
            ReactDOM.createPortal( 
                <MessageBeforeList 
                    text={{value:`Descargá tu reporte `,url:noti.url,name_url:<Icon name='download' className='color_search' inverted circular />}} 
                    closeMessage={true} 
                    onCloseMessage={close} 
                    warning={false} 
                    info={true}
                    header={`Fecha: ${noti.fecha} `}
                />,
                portalRoot
            )
        ));
    }, [parsedData, portalRoot, close]);

    return (
        <>
            <Icon style={{padding: "0px",marginRight: "0px",marginLeft: "7px"}} name={lastNotificationInfo ? 'bell' : 'bell outline'} className={`top-menu-admin__color_brown`} onClick={viewNotification}/>

            {(lastNotificationInfo) &&
                <div
                    className="notification-badge"
                    style={{
                        position: 'absolute',
                        top: '-6px',
                        right: '-6px',
                        background: '#9E9E9E',
                        color: 'white',
                        borderRadius: '50%',
                        padding: '4px',
                        fontSize: '12px',
                        width: '20px',
                        height: '20px',
                        justifyContent: 'center',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    {count}
                </div>
            }
            {(parsedData.length > 0 && showMessage) && MensajeNot}
        </>
    )
})

